import { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Avatar,
  Autocomplete,
  FormControlLabel,
  Checkbox,
  IconButton,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  InputAdornment,
} from "@mui/material";
import { rsActiveMenu, rsScrollCk, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { ArrowBackRounded, Delete } from "@mui/icons-material";
import ReplyIcon from "@mui/icons-material/Reply";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { UseComment } from "./UseComment";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import DeleteRow from "../../components/DeleteRow";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import UserProfule from "./UserProfule";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import useBreakpoints from "../../hooks/useBreakpoints";
import NoAccountsIcon from "@mui/icons-material/NoAccounts";

export default function CommentDetail(props) {
  const {
    GetSigns,
    GetMessages,
    ChangeOperator,
    GetOperators,
    submitComment,
    UpdateComment,
    DeleteComment,
  } = UseComment();
  const [defaultMassages, setDefaultMassages] = useState();
  const [signatures, setSignatures] = useState();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [showCkEditor, setShowCkEditor] = useState({
    show: false,
    commentId: undefined,
  });
  const [details, setDetails] = useState();
  const [showNotConfirm, setShowNotConfirm] = useState({
    show: false,
    AnswerToID: undefined,
  });
  const [showConfirm, setShowConfirm] = useState({
    show: false,
    AnswerToID: undefined,
  });
  const [msScrollCk, setMsScrollCk] = useState(false);
  const [isEdit, setIsEdit] = useState({
    commentID: undefined,
    isEdit: false,
    message: "",
  });
  const [operatorsRes, setOperatorsRes] = useState();
  const [emzaValue, setEmzaValue] = useState();
  const [sendUnknown, setSendUnknown] = useState(false);
  const [operatorChange, setOperatorChange] = useState({
    CommentID: undefined,
    newUserID: undefined,
  });
  const [sendReplyModel, setSendReplyModel] = useState({
    Message: "",
    IsPrivate: false,
    IsUnknown: false,
  });
  const [deleteState, setDeleteState] = useState({
    show: false,
    id: undefined,
  });
  const [privateState, setPrivateState] = useState({
    show: false,
    id: undefined,
  });
  const [openProfile, setOpenProfile] = useState({
    show: false,
    id: undefined,
  });

  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (props.detailCom) {
      GetOperators((callback) => {
        const uniqueOperators = Array.from(
          new Map((callback || []).map((item) => [item.userID, item])).values()
        );
        setOperatorsRes(uniqueOperators);
      });
      setDetails(props.detailCom);
      setShowCkEditor({
        show: false,
        commentId: undefined,
      });
      setSendReplyModel({
        ...sendReplyModel,
        Message: "",
        IsPrivate: props.detailCom.totalIsPrivate,
      });
    }
  }, [props.detailCom]);

  useEffect(() => {
    if (msScrollCk) {
      const element = document.getElementById("scrollToinja");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
          setMsScrollCk(false);
        }
      }, 1000);
    }
  }, [msScrollCk]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        mb: 2,
        mx: 2,
      }}
    >
      <Dialog
        // BackdropProps={{
        //   style: {
        //     backgroundColor: "transparent",
        //   },
        // }}
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={privateState.show}
        onClose={() => setPrivateState({ ...privateState, show: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle color="red" id="alert-dialog-title">
          توجه!
        </DialogTitle>
        <DialogContent>
          {privateState.isPrivate == true ? (
            <DialogContentText id="alert-dialog-description">
              آیا از غیرخصوصی نمودن کامنت اطمینان دارید؟
            </DialogContentText>
          ) : (
            <DialogContentText id="alert-dialog-description">
              آیا از خصوصی نمودن کامنت اطمینان دارید؟
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ color: "#565656 !important" }}
            onClick={() => {
              if (privateState.isPrivate == true) {
                let model = {
                  CommentID: privateState.id,
                  IsPrivate: false,
                };
                UpdateComment(model, () => {
                  props.callBYID(details.id);
                  props.setRefresh(true);
                  props.setPageState(props.pageState);
                });
                setPrivateState({ ...privateState, show: false });
              } else {
                let model = {
                  CommentID: privateState.id,
                  IsPrivate: true,
                };

                UpdateComment(model, () => {
                  props.callBYID(details.id);
                  props.setRefresh(true);
                  props.setPageState(props.pageState);
                });
                setPrivateState({ ...privateState, show: false });
              }
            }}
          >
            بله
          </Button>
          <Button
            color="secondary"
            onClick={() => setPrivateState({ ...privateState, show: false })}
          >
            خیر
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={showConfirm.show}
        onClose={() => setShowConfirm({ ...showConfirm, show: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle color="red" id="alert-dialog-title">
          توجه!
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            آیا از ثبت کامنت اطمینان دارید؟
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ color: "#565656 !important" }}
            onClick={() => {
              var sendModel = {
                Message: sendReplyModel.Message ? sendReplyModel.Message : "",
                AnswerToID: showConfirm.AnswerToID,
                IsUnknown: sendReplyModel.IsUnknown,
                IsPrivate: sendReplyModel.IsPrivate,
                Confirm: true,
              };
              submitComment(sendModel, () => {
                setShowConfirm({ ...showConfirm, show: false });
                props.setRefresh(true);
                props.setPageState(props.pageState);
                props.callBYID(details.id);
              });
            }}
          >
            بله
          </Button>
          <Button
            color="secondary"
            onClick={() => setShowConfirm({ ...showConfirm, show: false })}
          >
            خیر
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={showNotConfirm.show}
        onClose={() => setShowNotConfirm({ ...showNotConfirm, show: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle color="red" id="alert-dialog-title">
          توجه!
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            آیا از عدم تایید کامنت اطمینان دارید؟
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ color: "#565656 !important" }}
            onClick={() => {
              var sendModel = {
                Message: sendReplyModel.Message,
                AnswerToID: showNotConfirm.AnswerToID,
                IsPrivate: sendReplyModel.IsPrivate,
                IsUnknown: sendReplyModel.IsUnknown,
                Confirm: false,
              };
              submitComment(sendModel, () => {
                setShowNotConfirm({ ...showNotConfirm, show: false });
                props.setRefresh(true);
                props.setPageState(props.pageState);
                props.callBYID(details.id);
              });
            }}
          >
            بله
          </Button>
          <Button
            color="secondary"
            onClick={() =>
              setShowNotConfirm({ ...showNotConfirm, show: false })
            }
          >
            خیر
          </Button>
        </DialogActions>
      </Dialog>

      <Typography sx={{ mb: 2, color: "secondary.main" }} variant="h6">
        جزئیات کامنت
      </Typography>
      <Box
        mb={2}
        sx={{
          display: isSmall ? "flex" : "grid",
          flexDirection: isSmall && "column",
        }}
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gap={3}
      >
        <Box gridColumn="span 2">
          <TextField
            fullWidth
            id="outlined-basic"
            value={details && details.id ? details.id : ""}
            label="شماره کامنت"
            size="small"
            sx={{
              input: {
                direction: "rtl",
              },
            }}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              readOnly: true,
            }}
            variant="filled"
          />
        </Box>
        <Box gridColumn="span 4">
          <TextField
            fullWidth
            id="outlined-basic"
            value={details && details.pageTitle ? details.pageTitle : ""}
            label="عنوان صفحه"
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              readOnly: true,
            }}
            sx={{
              input: {
                cursor: "pointer",
              },
            }}
            onClick={() => {
              window.open(
                details && details.pageURL && details.pageURL,
                "_blank"
              );
            }}
            variant="filled"
          />
        </Box>
        <Box gridColumn="span 3">
          <TextField
            fullWidth
            id="outlined-basic"
            value={details && details.userName ? details.userName : ""}
            label="نام کاربر"
            size="small"
            onClick={() => {
              setOpenProfile({
                show: true,
                mobile: details.mobile ? details.mobile : "",
              });
            }}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <AccountBoxIcon
                    color="secondary"
                    sx={{ cursor: "pointer" }}
                    onClick={() => {
                      setOpenProfile({
                        show: true,
                        mobile: details.mobile ? details.mobile : "",
                      });
                    }}
                  ></AccountBoxIcon>
                </InputAdornment>
              ),
            }}
            sx={{
              input: {
                textAlign: "center",
                cursor: "pointer",
              },
            }}
            InputLabelProps={{
              shrink: true,
            }}
            variant="filled"
          />
        </Box>
        <Box gridColumn="span 3">
          <TextField
            fullWidth
            id="outlined-basic"
            value={details && details.mobile ? details.mobile : ""}
            label="موبایل"
            size="small"
            sx={{
              input: {
                direction: "rtl",
              },
            }}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              readOnly: true,
            }}
            variant="filled"
          />
        </Box>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
        <Typography sx={{ mr: 1 }} variant="body1">
          اپراتور/اپراتورها :{" "}
        </Typography>
        {details &&
          details.transfer &&
          details.transfer.map((model, i) => {
            return (
              <Box sx={{ display: "flex", alignItems: "center" }} key={i}>
                <Avatar src={model.avatar}></Avatar>
                <Typography variant="body2" sx={{ ml: 1 }}>
                  {model.userName}
                </Typography>
                {details.transfer[i + 1] && (
                  <ArrowBackRounded sx={{ color: "secondary.main", mx: 2 }} />
                )}
              </Box>
            );
          })}
      </Box>
      {props.getComment == 1 && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            my: 2,
          }}
        >
          {operatorsRes && (
            <Autocomplete
              size="small"
              onChange={(event, newValue) => {
                let Array = details && details.conversation;
                var lastComment =
                  Array &&
                  Array[Array.length - 1] &&
                  Array[Array.length - 1].id;
                setOperatorChange({
                  CommentID: lastComment,
                  newUserID: newValue,
                });
              }}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              getOptionLabel={(option) => {
                if (option) {
                  return operatorsRes.find((m) => m.userID == option).operator;
                }
                return "";
              }}
              sx={{ width: "30%", mr: 2 }}
              options={operatorsRes ? operatorsRes.map((m) => m.userID) : []}
              renderInput={(params) => (
                <TextField
                  variant="outlined"
                  {...params}
                  label="انتقال به اپراتور"
                />
              )}
            />
          )}

          <Button
            onClick={() => {
              ChangeOperator(operatorChange, () => {
                props.setRefresh(true);
                props.setPageState(props.pageState);
                props.callBYID(details.id);
              });
            }}
            variant="contained"
          >
            ثبت
          </Button>
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          bgcolor: "#F5F5F5",
          borderRadius: "6px",
          boxShadow: "-2px 8px 8px 0px #14141433",
          mt: 2,
          p: 2,
          width: "90%",
          mx: "auto",
          mb: 3,
        }}
      >
        {details &&
          details.conversation &&
          details.conversation.map((model, i) => {
            return (
              <Box
                key={i}
                sx={{
                  ml: i !== 0 ? 4 : 0,
                  mb: 2,
                  borderLeft: i !== 0 && "3px solid ",
                  borderColor: window.ENV.primary,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: isSmall ? "column" : "row",
                    gap: isSmall && 2,
                    alignItems: "center",
                    justifyContent: "space-between",
                    ml: i !== 0 && 2,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {model.isUnknown ? (
                      <NoAccountsIcon sx={{ mr: 1 }} fontSize="large" />
                    ) : (
                      <Avatar sx={{ mr: 1 }} src={model.avatar}></Avatar>
                    )}
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <Typography
                        sx={{
                          color: model.userID == 0 && "primary.main",
                        }}
                        variant="subtitle1"
                      >
                        {model.isUnknown
                          ? model.userName + " (" + " ناشناس " + ")"
                          : model.userName}
                      </Typography>
                      <Typography variant="caption">{model.id}</Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <IconButton sx={{ p: 0 }}>
                      {model.state == 1 && (
                        <CheckIcon style={{ color: "#618833" }} />
                      )}
                      {model.state == 2 && (
                        <CloseOutlinedIcon style={{ color: "red" }} />
                      )}
                      {model.state == 0 && <QuestionMarkIcon />}
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        setDeleteState({
                          show: true,
                          id: model.id,
                        });
                      }}
                      sx={{ p: 0 }}
                    >
                      <DeleteIcon color="secondary" fontSize="small" />
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        setPrivateState({
                          show: true,
                          id: model.id,
                          isPrivate: model.isPrivate,
                        });
                      }}
                      sx={{ p: 0, mx: 1 }}
                    >
                      {model.isPrivate == false ? (
                        <VisibilityIcon color="primary" fontSize="small" />
                      ) : (
                        <VisibilityOffIcon color="error" fontSize="small" />
                      )}
                    </IconButton>
                    <Typography variant="subtitle2" sx={{ direction: "rtl" }}>
                      {model.shamsiDate}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    mt: 2,
                    ml: i !== 0 && 2,
                  }}
                >
                  <Avatar sx={{ mr: 1, visibility: "hidden" }}>
                    {model.avatar}
                  </Avatar>
                  <Typography
                    sx={{ whiteSpace: "pre-wrap" }}
                    variant="subtitle1"
                    dangerouslySetInnerHTML={{
                      __html: model.message,
                    }}
                  ></Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  {model.userID == 0 && (
                    <Button
                      onClick={() => {
                        setMsScrollCk(true);
                        setSendReplyModel({
                          ...sendReplyModel,
                          Message: model.message,
                        });
                        setIsEdit({ commentID: model.id, isEdit: true });
                        setShowCkEditor({ show: true, commentId: model.id });
                        GetSigns((callback) => {
                          setSignatures(callback);
                        });
                        GetMessages((callback) => {
                          setDefaultMassages(callback);
                        });
                      }}
                      color="secondary"
                      sx={{ mr: 2, width: "80px" }}
                      variant="contained"
                    >
                      ویرایش
                    </Button>
                  )}
                  {model.state !== 1 && (
                    <Button
                      onClick={() => {
                        setSendReplyModel({
                          ...sendReplyModel,
                          IsUnknown: model.isUnknown,
                        });
                        setShowConfirm({ show: true, AnswerToID: model.id });
                      }}
                      sx={{ mr: 2, width: "80px" }}
                      variant="contained"
                    >
                      تایید
                    </Button>
                  )}

                  {model.state !== 2 && (
                    <Button
                      onClick={() => {
                        setSendReplyModel({
                          ...sendReplyModel,
                          IsUnknown: model.isUnknown,
                        });
                        setShowNotConfirm({ show: true, AnswerToID: model.id });
                      }}
                      color="error"
                      sx={{ mr: 2, width: "80px" }}
                      variant="contained"
                    >
                      عدم تایید
                    </Button>
                  )}
                  <Button
                    sx={{ width: "80px" }}
                    onClick={() => {
                      setMsScrollCk(true);
                      setShowCkEditor({ show: true, commentId: model.id });
                      GetSigns((callback) => {
                        setSignatures(callback);
                      });
                      GetMessages((callback) => {
                        setDefaultMassages(callback);
                      });
                    }}
                    variant="outlined"
                  >
                    <ReplyIcon />
                    پاسخ
                  </Button>
                </Box>
                <Divider sx={{ m: 2, mb: 0 }} />
              </Box>
            );
          })}
      </Box>
      {showCkEditor.show && (
        <Box
          id="scrollToinja"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "90%",
            mx: "auto",
            mb: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              mb: 3,
            }}
          >
            {defaultMassages && (
              <Autocomplete
                size="small"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let text = defaultMassages.find(
                      (m) => m.id == newValue
                    )?.message;
                    setSendReplyModel({
                      ...sendReplyModel,
                      Message: text,
                    });
                  }
                }}
                value=""
                isOptionEqualToValue={(option, value) => {
                  return value == "" || option === value;
                }}
                getOptionLabel={(option) => {
                  if (option && defaultMassages) {
                    return (
                      defaultMassages &&
                      defaultMassages.find((m) => m.id == option).title
                    );
                  }
                  return "";
                }}
                sx={{ width: "30%" }}
                options={defaultMassages?.map((m) => m.id)}
                renderInput={(params) => (
                  <TextField
                    variant="outlined"
                    {...params}
                    label="پیام های آماده"
                  />
                )}
              />
            )}
          </Box>
          <CKEditor
            config={{
              language: "fa",
              link: {
                decorators: {
                  addTargetToExternalLinks: {
                    mode: "automatic",
                    callback: (url) => /^(https?:)?\/\//.test(url),
                    attributes: {
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                },
              },
            }}
            editor={Editor}
            style={{ p: "100px", width: "100%" }}
            data={sendReplyModel.Message ? sendReplyModel.Message : ""}
            onChange={(event, editor) => {
              const data = editor.getData();
              setSendReplyModel({
                ...sendReplyModel,
                Message: data,
              });
            }}
            onReady={(editor) => {
              editor.editing.view.change((writer) => {
                writer.setStyle(
                  "height",
                  "350px",
                  editor.editing.view.document.getRoot()
                );
              });
            }}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              mb: 2,
            }}
          >
            {signatures && (
              <Autocomplete
                size="small"
                onChange={(event, newValue) => {
                  if (newValue) {
                    var text =
                      sendReplyModel.Message +
                      "&nbsp;" +
                      "&nbsp;" +
                      signatures.find((m) => m.id == newValue)?.message;
                    setSendReplyModel({ ...sendReplyModel, Message: text });
                  }
                }}
                value=""
                isOptionEqualToValue={(option, value) => {
                  return value == "" || option === value;
                }}
                getOptionLabel={(option) => {
                  if (option && signatures) {
                    return (
                      signatures && signatures.find((m) => m.id == option).title
                    );
                  }
                  return "";
                }}
                sx={{ width: "30%", mt: 3 }}
                options={signatures?.map((m) => m.id)}
                renderInput={(params) => (
                  <TextField
                    value={emzaValue ? emzaValue : ""}
                    variant="outlined"
                    {...params}
                    label="امضا پیام"
                  />
                )}
              />
            )}
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              mb: 2,
            }}
          >
            {signatures && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={sendReplyModel.IsPrivate}
                    onChange={(event) =>
                      setSendReplyModel({
                        ...sendReplyModel,
                        IsPrivate: event.target.checked,
                      })
                    }
                  />
                }
                label="کامنت به صورت خصوصی ثبت شود"
              />
            )}
            {signatures && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={sendReplyModel.IsUnknown}
                    onChange={(event) => setSendUnknown(event.target.checked)}
                  />
                }
                label="کامنت به صورت ناشناس ثبت شود"
              />
            )}
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-around" }}>
            <Button
              onClick={() => {
                if (isEdit.isEdit) {
                  let model = {
                    CommentID: isEdit.commentID,
                    Message: sendReplyModel.Message
                      ? sendReplyModel.Message
                      : "",
                  };

                  UpdateComment(model, () => {
                    setIsEdit({ commentID: undefined, isEdit: false });
                    props.callBYID(details.id);
                    props.setRefresh(true);
                    props.setPageState(props.pageState);
                  });
                } else {
                  var sendModel = {
                    Message: sendReplyModel.Message
                      ? sendReplyModel.Message
                      : "",
                    AnswerToID: showCkEditor.commentId,
                    IsPrivate: sendReplyModel.IsPrivate,
                    IsUnknown: sendUnknown,
                    Confirm: true,
                  };
                  submitComment(sendModel, () => {
                    props.setRefresh(true);
                    props.setPageState(props.pageState);
                    props.callBYID(details.id);
                  });
                }
              }}
              color="secondary"
              sx={{ mr: 2, width: "80px" }}
              variant="contained"
            >
              ثبت
            </Button>
            <Button
              onClick={() => {
                setShowCkEditor({ ...showCkEditor, show: false });
                setSendReplyModel({
                  ...sendReplyModel,
                  Message: "",
                });
              }}
              color="secondary"
              sx={{ mr: 2, width: "80px" }}
              variant="outlined"
            >
              انصراف
            </Button>
          </Box>
        </Box>
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"کامنت"}
        callback={() => {
          setProgress(true);
          DeleteComment(deleteState.id, () => {
            props.callBYID(details.id);
            props.setRefresh(true);
            props.setPageState(props.pageState);
            props.callBYID(details.id);
          });
        }}
      ></DeleteRow>
      {openProfile && (
        <UserProfule
          setMsScrollComment={props.setMsScrollComment}
          callBYID={props.callBYID}
          openProfile={openProfile}
          setOpenProfile={setOpenProfile}
        ></UserProfule>
      )}
    </Box>
  );
}
